<template>
  <div class="ppage">
    <header class="ppage-head">
      <div class="ppage-wrap">
        <p class="crumb"><router-link to="/">Gestionnaire Citron</router-link><span aria-hidden="true"> / </span><span>{{ crumb || title }}</span></p>
        <h1>{{ title }}</h1>
        <p v-if="lead" class="lead">{{ lead }}</p>
      </div>
    </header>

    <div class="ppage-wrap ppage-body">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  /**
   * Page d'information (légal, qui sommes-nous, assistance, tarif) : un bandeau sur papier réglé avec le titre,
   * puis le contenu dans une colonne centrée. Props : title, lead (phrase d'introduction), crumb (nom dans le fil d'Ariane, par défaut le titre).
   */
  export default {
    name: 'PublicPage',
    props: {
      title: {type: String, required: true},
      lead: {type: String, default: ''},
      crumb: {type: String, default: ''},
    }
  }
</script>

<style lang="stylus" scoped>
@require '~/src/common/style/public.styl';

.ppage
  flex 1 0 auto
  display flex
  flex-direction column
  background-color PUB_PAPER

.ppage-wrap
  pub-container()

.ppage-head
  padding-top clamp(24px, 4vw, 44px)
  padding-bottom clamp(24px, 4vw, 40px)
  border-bottom 1px solid PUB_RULE
  background-color PUB_PAPER
  h1
    margin 16px 0 0
    color PUB_INK
    font-family PUB_FONT_DISPLAY
    font-weight 400
    font-size clamp(2rem, 4.6vw, 2.9rem) !important
    line-height 1.15
    letter-spacing -0.01em
    text-align left
  .lead
    margin 14px 0 0
    max-width 60ch
    color PUB_INK_SOFT
    font-family PUB_FONT_TEXT
    font-size clamp(1.05rem, 2vw, 1.25rem)
    line-height 1.55

.crumb
  margin 0
  color PUB_MUTED
  font-family PUB_FONT_TEXT
  font-size 0.95rem
  a
    color PUB_MUTED
    font-family PUB_FONT_TEXT
    font-weight 400
    text-decoration underline
    text-decoration-color PUB_RULE
    text-decoration-thickness 2px
    text-underline-offset 0.18em
    &:hover
      color PUB_INK
      background-color PUB_LEMON
  span
    font-family PUB_FONT_TEXT
  span:last-child
    color PUB_INK
    font-weight 600

.ppage-body
  flex 1 0 auto
  padding-top clamp(32px, 5vw, 56px)
  padding-bottom clamp(48px, 8vw, 96px)
</style>
